import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0005 15C12.7961 15 13.5592 14.6839 14.1218 14.1213C14.6844 13.5587 15.0005 12.7956 15.0005 12C15.0005 11.2044 14.6844 10.4413 14.1218 9.87868C13.5592 9.31607 12.7961 9 12.0005 9C11.2048 9 10.4418 9.31607 9.87917 9.87868C9.31656 10.4413 9.00049 11.2044 9.00049 12C9.00049 12.7956 9.31656 13.5587 9.87917 14.1213C10.4418 14.6839 11.2048 15 12.0005 15Z"
        fill={colorValue}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.32356 11.447C2.81156 6.976 7.02856 3.75 12.0016 3.75C16.9716 3.75 21.1866 6.973 22.6766 11.44C22.7966 11.802 22.7966 12.192 22.6766 12.553C21.1896 17.024 16.9716 20.25 11.9996 20.25C7.02956 20.25 2.81356 17.027 1.32456 12.56C1.20431 12.1987 1.20431 11.8083 1.32456 11.447H1.32356ZM17.2506 12C17.2506 13.3924 16.6974 14.7277 15.7129 15.7123C14.7283 16.6969 13.393 17.25 12.0006 17.25C10.6082 17.25 9.27282 16.6969 8.28825 15.7123C7.30369 14.7277 6.75056 13.3924 6.75056 12C6.75056 10.6076 7.30369 9.27226 8.28825 8.28769C9.27282 7.30312 10.6082 6.75 12.0006 6.75C13.393 6.75 14.7283 7.30312 15.7129 8.28769C16.6974 9.27226 17.2506 10.6076 17.2506 12Z"
        fill={colorValue}
      />
    </svg>
  );
};
